"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.settingColumns = exports.settingEntityName = void 0;
exports.defineSettingMap = defineSettingMap;
const storage_1 = require("@juvare/platform-shared/features/storage");
exports.settingEntityName = 'setting';
exports.settingColumns = (0, storage_1.defineColumns)({
    name: {
        type: 'string-required',
        index: 'unique',
    },
    description: {
        type: 'string-required',
        index: true,
    },
    value: {
        type: 'string-required',
        index: false,
    },
    defaultValue: {
        type: 'string-required',
        index: false,
    },
    type: {
        type: 'string-required',
        index: true,
    },
    group: {
        type: 'string-required',
        index: true,
    },
    public: {
        type: 'boolean-required',
    },
    changed: {
        type: 'boolean-required',
        index: true,
    },
    search: {
        type: 'full-text-search-required',
        language: 'english',
    },
    readOnly: {
        type: 'boolean-required',
    },
});
function defineSettingMap(settingMap) {
    return settingMap;
}
